'use client'
import React, {useState, useRef} from 'react'
import {Button} from '@local/ui/components'

type TabProps = {
	title: string
	items: {
		name: string
		title: string
		content: React.ReactNode
	}[]
}

export const Tab = ({title, items}: TabProps) => {
	const [activeTab, setActiveTab] = useState(items[0].name)
	const contentRef = useRef<HTMLDivElement>(null)

	return (
		<div className='relative max-w-full gap-24 overflow-hidden flex flex-col lg:gap-y-40'>
			<h2 className='text-28 lg:text-34 font-serif font-medium leading-tight'>{title}</h2>
			<div className='grid grid-cols-3 gap-x-8'>
				{items.map((item) => (
					<Button
						label={item.title}
						small
						variant={activeTab === item.name ? 'primary' : 'secondary-transparent'}
						key={item.name}
						onClick={() => setActiveTab(item.name)} />
				))}
			</div>
			<div className='w-full max-w-3xl text-pretty h-full mt-14' ref={contentRef}>

				<div>
					{items.find((item) => item.name === activeTab)?.content}
				</div>

			</div>
		</div>
	)
}
